<template functional>
  <v-tooltip bottom nudge-top content-class="text-xs-center" max-width="200">
    <nx-chip class="hidden-sm-and-down" slot="activator" :color="props.publishOnVideoTranscoded ? 'green' : 'orange' ">
      {{ parent.$tc(
      `message.content.editor.video.transcoding.${props.publishOnVideoTranscoded ?
        'available' : 'unavailable' }`)
      }}
      <v-icon
        class="ml-2"
        small
        :color="props.publishOnVideoTranscoded ? 'accent' : 'warning' "
      >help</v-icon>
    </nx-chip>
    <span v-if="!props.publishOnVideoTranscoded"
      v-html="parent.$t('message.content.editor.video.transcoding.pending')">
    </span>
    <span v-else v-html="parent.$t('message.content.editor.video.transcoding.ready')"></span>
  </v-tooltip>
</template>

<script>
import NxChip from '@/components/chips/Chip';

export default {
  name: 'nx-content-editor-header-video-chip',
  components: { NxChip },
  props: {
    publishOnVideoTranscoded: Boolean,
  },
};
</script>
